/* Geurvinder UI rendering: methods mixed into the <geur-vinder> element. All text comes from this.T (translations). */
(function () {
  'use strict';
  var E = window.GeurvinderEngine, U = window.GeurvinderUI, ICONS = U.ICONS, esc = U.esc, bottle = U.bottle, fmt = U.fmt;
  var list = E._internal.list;

  // a product's name and link in the visitor's language (P.loc = translated data, when fetched)
  function nameOf(P) { return P.loc && P.loc.t ? E.displayTitle(P.loc.t, P.vendor) : P.name; }
  function urlOf(P, root) { return P.loc && P.loc.u ? P.loc.u : U.local(P.raw.u, root); }

  U.view = {
    // ---------- rendering ----------
    renderProfile() {
      if (!this.profile) return;
      var self = this, T = this.T, any = false;
      this.profile.innerHTML = this.steps.map(function (s, j) {
        var val = self.answerLabel(s);
        if (val) any = true;
        var cur = self.mode === 'quiz' && self.A.mode !== 'like' && j === self.stepIndex;
        return '<li class="gv-prof__item' + (cur ? ' is-current' : '') + (val ? ' is-done' : '') + '">' +
          '<span class="gv-prof__k">' + esc(s.short) + '</span>' +
          (val
            ? '<button type="button" class="gv-prof__v" data-gv-edit="' + j + '" aria-label="' + esc(fmt(T.edit_aria, { k: s.short, v: val })) + '">' + esc(val) + '</button>'
            : '<span class="gv-prof__v is-empty">–</span>') +
          '</li>';
      }).join('');
      this.profile.hidden = !any;
    },

    renderStage(focus) {
      this.mode = 'quiz';
      var s = this.steps[this.stepIndex], i = this.stepIndex, n = this.steps.length, self = this, T = this.T;
      var opts = s.options.map(function (o) {
        var on = s.multi ? self.A.fams.indexOf(o.v) >= 0 : self.A[s.id] === o.v;
        var lead = o.swatch ? '<span class="gv-opt__swatch" style="--sw:' + o.swatch + '"></span>'
          : o.icon ? '<span class="gv-opt__icon">' + ICONS[o.icon] + '</span>' : '';
        return '<button type="button" class="gv-opt" data-gv-opt="' + o.v + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
          lead + '<span class="gv-opt__text"><span class="gv-opt__label">' + esc(o.l) + '</span>' +
          (o.h ? '<span class="gv-opt__hint">' + esc(o.h) + '</span>' : '') + '</span>' +
          '<span class="gv-opt__check" aria-hidden="true">' + ICONS.check + '</span></button>';
      }).join('');
      var dots = this.steps.map(function (x, j) { return '<span class="' + (j < i ? 'is-done' : j === i ? 'is-on' : '') + '"></span>'; }).join('');
      this.stage.innerHTML =
        '<div class="gv-q gv-enter">' +
          '<div class="gv-q__top">' +
            (i > 0 ? '<button type="button" class="gv-link" data-gv-back>← ' + esc(T.back) + '</button>' : '') +
            '<span class="gv-q__count">' + esc(fmt(T.step, { i: i + 1, n: n })) + '</span>' +
          '</div>' +
          '<div class="gv-progress" aria-hidden="true">' + dots + '</div>' +
          (s.id === 'gender' && this.cfg.gift !== false ?
            '<div class="gv-seg" role="group" aria-label="' + esc(T.who_aria) + '">' +
              '<button type="button" data-gv-gift="0" aria-pressed="' + !this.A.gift + '">' + esc(T.for_me) + '</button>' +
              '<button type="button" data-gv-gift="1" aria-pressed="' + !!this.A.gift + '">' + ICONS.gift + esc(T.gift) + '</button>' +
            '</div>' : '') +
          '<h3 class="gv-q__title" tabindex="-1">' + esc(s.title) + '</h3>' +
          (s.sub ? '<p class="gv-q__sub">' + esc(s.sub) + '</p>' : '') +
          '<div class="gv-options' + (s.options.length === 4 ? ' gv-options--4' : '') + (s.options.length === 6 ? ' gv-options--6' : '') + '" role="group" aria-label="' + esc(s.title) + '">' + opts + '</div>' +
          (s.multi ? '<div class="gv-q__actions"><button type="button" class="gv-btn" data-gv-next' + (this.A.fams.length ? '' : ' disabled') + '>' + esc(T.next) + '</button>' +
            (this.A.gift ? '<button type="button" class="gv-link" data-gv-unknown>' + esc(T.unknown) + '</button>' : '') + '</div>' : '') +
        '</div>';
      if (focus) this.focusTitle('.gv-q__title');
    },

    focusTitle(sel) {
      var h = this.stage.querySelector(sel);
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
      var top = this.getBoundingClientRect().top;
      if (top < 0) this.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    },

    renderResults(keepFocus) {
      var per = this.cfg.results || 3, T = this.T, A = this.A;
      var like = A.mode === 'like';
      var list = this.results || [];
      var shown = list.slice(0, per * this.page);
      var quoted = fmt(T.q_quoted, { q: A.like });
      var html;
      if (!list.length) {
        html = like
          ? '<h3 class="gv-res__title" tabindex="-1">' + esc(fmt(T.nolike_title, { q: A.like })) + '</h3>' +
            '<p class="gv-res__sub">' + esc(fmt(T.nolike_text, { n: this.steps.length })) + '</p>' +
            '<div class="gv-res__actions"><button type="button" class="gv-btn" data-gv-quiz>' + esc(T.start_quiz) + '</button></div>'
          : '<h3 class="gv-res__title" tabindex="-1">' + esc(T.nomatch_title) + '</h3>' +
            '<p class="gv-res__sub">' + esc(T.nomatch_text) + '</p>' +
            '<div class="gv-res__actions"><button type="button" class="gv-btn" data-gv-back>' + esc(T.edit_answers) + '</button></div>';
      } else {
        var M = this.matcher, R = M && M.R;
        var head = like
          ? (R ? fmt(T.like_head, { x: R.n }) : M && M.note ? fmt(T.note_head, { x: A.like }) : fmt(T.like_head, { x: quoted }))
          : A.gift ? (A.gender === 'him' ? T.gift_head_him : A.gender === 'her' ? T.gift_head_her : T.gift_head)
          : fmt(T.top_head, { n: Math.min(per, list.length) });
        var direct = list.filter(function (r) { return r.like >= 0.8; }).length;
        var rn = R ? (R.b && R.b.split(' ').every(function (w) { return R.n.indexOf(w) < 0; }) ? fmt(T.ref_by, { n: R.n, b: R.b }) : R.n) : '';
        var sub;
        if (like && R && !direct) sub = fmt(T.sub_nodupe, { x: rn });
        else if (like && R) sub = fmt(direct === 1 ? T.sub_direct_one : T.sub_direct_other, { n: direct, x: rn }) + (list.length > direct ? ' ' + T.sub_then : '');
        else if (like) sub = fmt(list.length === 1 ? T.sub_count_one : T.sub_count_other, { n: list.length });
        else sub = fmt(A.like ? T.sub_pool_like : T.sub_pool, { n: this.poolSize.toLocaleString(this.cfg.locale || 'nl'), q: A.like });
        var self = this;
        html =
          '<div class="gv-q__top">' + (like ? '<button type="button" class="gv-link" data-gv-quiz>← ' + esc(T.to_questions) + '</button>' : '<button type="button" class="gv-link" data-gv-back>← ' + esc(T.edit_answers) + '</button>') + '</div>' +
          '<h3 class="gv-res__title" tabindex="-1">' + esc(head) + '</h3>' +
          '<p class="gv-res__sub">' + esc(sub) + '</p>' +
          '<div class="gv-grid">' + shown.map(function (r, i) { return self.card(r, i); }).join('') + '</div>' +
          (A.gift ? this.giftRow() : '') +
          '<div class="gv-res__actions">' +
            (shown.length < list.length ? '<button type="button" class="gv-btn gv-btn--ghost" data-gv-more>' + esc(T.more) + '</button>' : '') +
            '<button type="button" class="gv-link" data-gv-restart>' + esc(T.restart) + '</button>' +
          '</div>';
      }
      this.stage.innerHTML = '<div class="gv-res' + (keepFocus ? '' : ' gv-enter') + '">' + html + '</div>';
      if (this.live) this.live.textContent = list.length ? fmt(list.length === 1 ? T.live_found_one : T.live_found_other, { n: list.length }) : T.live_none;
      if (!keepFocus) this.focusTitle('.gv-res__title');
    },

    // reason codes from the engine -> chip text
    reasonText(code) {
      var T = this.T;
      if (code.indexOf('f:') === 0) return T['f_' + code.slice(2)];
      return { gM: T.o_him, gF: T.o_her, gU: T.r_uni, day: T.r_day, eve: T.r_eve }[code] || '';
    },

    // notes to show on a card, in the visitor's language when the product has translated notes
    noteList(r) {
      var L = r.P.loc, out = { list: r.notes || [], same: !!r.notesSame };
      var ln = L ? list(L.n) : [];
      if (!ln.length) return out;
      var keepCase = /^de/.test(this.cfg.locale || '');
      var tidy = function (x) { x = String(x).trim(); return keepCase ? x : x.toLowerCase(); };
      if (ln.length === list(r.P.raw.n).length) out.list = (r.noteIdx || []).map(function (i) { return ln[i]; }).filter(Boolean).map(tidy);
      else { out.list = ln.slice(0, 3).map(tidy); out.same = false; }
      return out;
    },

    card(r, i) {
      var P = r.P, raw = P.raw, c = this.cfg, A = this.A, m = this.money, T = this.T, L = P.loc || {};
      var url = esc(urlOf(P, c.root)), self = this;
      var media = raw.i
        ? '<img src="' + esc(raw.i) + '" alt="" loading="lazy" width="360" height="360">'
        : bottle(P.color);
      var note = '';
      if (r.tier === 2) note = P.form === 'olie' ? T.note_oil : T.note_spray;
      else if (r.tier === 1 || r.flags.near) note = T.near_budget;
      var size = raw.vt && !/default/i.test(raw.vt) ? String(raw.vt).replace(/(\d)\s*ml\b/i, '$1 ml') : '';
      var type = P.form === 'olie' ? T.o_oil : (L.y || raw.y || '');
      var meta = [size, type].filter(Boolean).join(' · ');
      var chips = (r.reasons || []).map(function (x) { return x === 'like' ? '' : self.reasonText(x); }).filter(Boolean)
        .map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('');
      var nl = this.noteList(r);
      var notes = nl.list.length ? '<p class="gv-card__notes"><span>' + esc(nl.same ? T.notes_same : T.notes) + ':</span> ' + nl.list.map(esc).join(' · ') + '</p>' : '';
      var likeName = L.l || P.like;
      var sample = c.showSample !== false && raw.s && !A.gift;
      var btn2 = sample
        ? '<button type="button" class="gv-btn gv-btn--ghost" data-gv-add="' + raw.s + '">' + esc(fmt(T.sample, { p: m(raw.sp) })) + '</button>'
        : '<button type="button" class="gv-btn gv-btn--ghost" data-gv-add="' + raw.m + '">' + esc(T.add) + '</button>';
      return '<article class="gv-card" style="--gv-tint:' + P.color + '">' +
        '<a class="gv-card__media' + (raw.i ? '' : ' is-placeholder') + '" href="' + url + '" data-gv-product="' + i + '" tabindex="-1" aria-hidden="true">' + media + '</a>' +
        '<span class="gv-match">' + esc(fmt(T.match, { n: r.pct })) + '</span>' +
        '<div class="gv-card__body">' +
          '<p class="gv-card__vendor">' + esc(P.vendor) + '</p>' +
          '<h4 class="gv-card__title"><a href="' + url + '" data-gv-product="' + i + '">' + esc(nameOf(P)) + '</a></h4>' +
          (likeName ? '<p class="gv-card__like' + (r.like >= 0.8 ? ' is-hit' : '') + '">' + esc(fmt(T.like_head, { x: likeName })) + '</p>' : '') +
          notes +
          (chips ? '<ul class="gv-chips">' + chips + '</ul>' : '') +
          (note ? '<p class="gv-card__note">' + esc(note) + '</p>' : '') +
          '<p class="gv-card__price"><strong>' + m(raw.p) + '</strong>' + (raw.c > raw.p ? '<s>' + m(raw.c) + '</s>' : '') +
          (meta ? '<span>' + esc(meta) + '</span>' : '') + '</p>' +
        '</div>' +
        '<div class="gv-card__actions"><a class="gv-btn" href="' + url + '" data-gv-product="' + i + '">' + esc(T.view) + '</a>' + btn2 + '</div>' +
      '</article>';
    },

    // "Liever een cadeauset?" row plus the gift card link, shown under gift results
    giftRow() {
      var m = this.money, c = this.cfg, T = this.T, sets = this.sets || [];
      var row = sets.map(function (o, i) {
        var P = o.P, raw = P.raw;
        var name = P.loc && P.loc.t ? E.setName(P.loc.t, P.vendor) : P.name;
        var why = o.why ? fmt(T.set_with, { x: nameOf(o.why.P) }) : P.vendor;
        return '<a class="gv-set" href="' + esc(urlOf(P, c.root)) + '" data-gv-set="' + i + '">' +
          '<span class="gv-set__media">' + (raw.i ? '<img src="' + esc(raw.i) + '" alt="" loading="lazy" width="120" height="120">' : bottle(P.color)) + '</span>' +
          '<span class="gv-set__body"><span class="gv-set__name">' + esc(name) + '</span>' +
          '<span class="gv-set__why">' + esc(why) + '</span>' +
          '<strong>' + m(raw.p) + '</strong></span></a>';
      }).join('');
      if (!row && !c.giftCard) return '';
      var card = '';
      if (c.giftCard) {
        var line = T['giftcard_' + ({ him: 'him', her: 'her' }[this.A.gender] || 'them')];
        card = '<p class="gv-gift__card">' + ICONS.gift + '<span>' +
          esc(line).replace(/\[([^\]]+)\]/, '<a href="' + esc(c.giftCard) + '">$1</a>') + '</span></p>';
      }
      return '<section class="gv-gift" aria-label="' + esc(T.gift_aria) + '">' +
        (row ? '<h4 class="gv-gift__title">' + esc(T.gift_alt) + '</h4><div class="gv-sets">' + row + '</div>' : '') +
        card + '</section>';
    },

    add(btn) {
      var id = Number(btn.getAttribute('data-gv-add'));
      if (!id || btn.disabled) return;
      var label = btn.innerHTML, self = this, T = this.T;
      btn.disabled = true;
      btn.classList.add('is-loading');
      this.adapter.addToCart(id, btn, this.cfg).then(function () {
        btn.innerHTML = ICONS.check + ' ' + esc(T.added);
        btn.classList.add('is-done');
        self.adapter.track('geurvinder_toegevoegd', { variant_id: id });
      }).catch(function () {
        btn.textContent = T.add_retry;
        btn.disabled = false;
        setTimeout(function () { btn.innerHTML = label; }, 2500);
      }).then(function () { btn.classList.remove('is-loading'); });
    }
  };
})();